/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchInput from "src/components/widgets/SearchInput";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { enableAccount, getDisabledAccounts } from "src/api/accounts";
import CustomDropdown from "src/components/CustomDropdown";
import { Button } from "src/components/ui/button";
import { EllipsisIcon } from "src/svg";
import CustomConfirmDialog from "src/components/CustomConfirmDialog";
import { showSuccessToast } from "src/lib/utils";
import BackIcon from "../images/back.png";
import useHasPermissions from "src/hooks/useHasPermissions";
import "src/array";

const DisabledAccounts = () => {
	const navigate = useNavigate();

	const { data } = useQuery({
		queryKey: ["accounts", "disabled"],
		queryFn: getDisabledAccounts,
		suspense: true,
	});

	const accounts = data?.data ?? [];

	return (
		<div className="pageWrapper">
			<div className="pageTop">
				<button className="mr-2 transparent-btn" onClick={() => navigate("/accounts")}>
					<img src={BackIcon} />
				</button>
				<h2>Inactive Bank Accounts</h2>
			</div>

			<div className="innerContent">
				<ActionBar />

				{accounts.length > 0 ? (
					<div className="tw-mt-10 tw-grid tw-gap-6 tw-grid-cols-[repeat(auto-fill,minmax(260px,1fr))]">
						{accounts.map((account, index) => (
							<Account account={account} key={index} />
						))}
					</div>
				) : (
					<div className="p-4 mb-4 dash-tables tw-text-center">
						<p>There are no disabled bank accounts.</p>
					</div>
				)}
			</div>
		</div>
	);
};

const ActionBar = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search");

	const updateSearchParams = (key, value) => {
		const newSearchParams = new URLSearchParams(searchParams);

		newSearchParams.set(key, value);

		setSearchParams(newSearchParams);
	};

	return (
		<div className="inner-top">
			<SearchInput
				name="search_text"
				type="text"
				placeholder="Search..."
				value={search}
				onChange={(event) => updateSearchParams("search", event.target.value)}
			/>
		</div>
	);
};

const Account = ({ account }) => {
	const { bank_name, account_number, tag_name } = account;
	const queryClient = useQueryClient();
	const hasEnablePermission = useHasPermissions("enable_bank_account");

	const { mutate: disable, isLoading: isDisableLoading } = useMutation(enableAccount, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["accounts"]);
		},
	});

	return (
		<div className="bank-acc-wrap">
			<div className="tw-flex tw-items-start tw-justify-between">
				<div className="acc-itm">
					<p className="small-txt">Bank Name</p>
					<h3>{bank_name}</h3>
				</div>
				<CustomDropdown
					trigger={
						<Button variant="hover">
							<EllipsisIcon />
						</Button>
					}
					actions={[].appendToArray(
						[
							{
								label: <CustomConfirmDialog trigger={<span>Enable Account</span>} mutateFn={() => disable({ uuid: account.uuid })} />,
								disabled: isDisableLoading,
							},
						],
						hasEnablePermission
					)}
				/>
			</div>
			<div className="acc-itm">
				<p className="small-txt">Account Number</p>
				<h3>{account_number}</h3>
			</div>
			<div className="">
				<p>Tag: {tag_name}</p>
			</div>
		</div>
	);
};

export default DisabledAccounts;
